import { Typography } from "@shared/ui.primitives";
import React from "react";

import { StrikethroughPrice } from "../../StrikethroughPrice/StrikethroughPrice";

import type { ProductCardDataType } from "./types";

type Props = {
  product: Pick<ProductCardDataType, "prices">;
};

export const HorizontalProductCardPricing: React.FC<Props> = ({ product }) => {
  const { prices } = product;
  const activePricing = prices[prices.activeType];

  if (activePricing.promo) {
    return (
      <StrikethroughPrice
        variant="horizontalProductCard"
        price={activePricing.regular.formatted}
        discountedPrice={activePricing.promo.formatted}
        dataTestId="horizontal-product-card-pricing"
      />
    );
  }

  return (
    <Typography variant="body-sm-bold" colour="primary-dark">
      {activePricing.regular.formatted}
    </Typography>
  );
};
